// Local enum, used by requests and responses
export enum Language {
  English = 'en',
  French = 'fr',
  ChineseTraditional = 'zh-TW',
  ChineseSimplified = 'zh-CN',
  Spanish = 'es',
  German = 'de',
  NorwegianBokmal = 'nb',
  NorwegianNynorsk = 'nn',
  Japanese = 'ja',
  Catalan = 'ca',
  Icelandic = 'is',
  Swedish = 'sv',
  Portuguese = 'pt',
}

export interface ITranslateTextRequest {
  text: string
  targetLanguage: Language // Use local enum
  sourceLanguage?: Language // Use local enum
}

export interface ITranslateTextResponse {
  translatedText: string
}

export interface ITranslateTextsRequest {
  texts: string[]
  targetLanguage: Language // Use local enum
  sourceLanguage?: Language // Use local enum
}

export interface ITranslateTextsResponse {
  translatedTexts: string[]
}

export interface IDetectLanguageRequest {
  text: string
}

// Detect response still uses the local enum
export interface IDetectLanguageResponse {
  detectedLanguage: Language
}
